import {
    createApp
} from 'vue'
import App from './App.vue'
// 引用路由
import router from './router'
//引入vuex
import store from './store'
import 'element-plus/dist/index.css'
import './assets/css/common.css'
import 'element-plus/theme-chalk/display.css'
//解决谷歌浏览器划动报错
import 'default-passive-events'
//引入全部组件
import ElementPlus from 'element-plus'
// 按需导入图标插件
import {
    registerIcons
} from '@/utils/icons'
//引入组件语言
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import {
    dayjs
} from "element-plus";
dayjs.en.weekStart = 1;
const app = createApp(App).use(store).use(router)
registerIcons(app)
app.use(ElementPlus, {
    size: 'default',
    zIndex: 3000,
    locale: zhCn
}).mount('#app')